import React from "react";
import { SvgIcon } from "@mui/material";
// assets
import styles from "src/components/UI/LeftCard/assets/scss/Menu.module.scss";

export const FreeIcon = () => {
  return (
    <SvgIcon className={styles.icon}>
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 94.35 93.34"
      >
        <defs></defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path
              style={{
                fill: "#18a74a",
                strokeWidth: 0,
              }}
              d="m48.08,1.81c1.09-.31,1.3-.7,2.52-1.08.51-.16,1.41-.38,2.52-.36.81.02,2.2.04,3.42.9.91.64.83,1.12,1.8,1.8,1.06.75,2.12.87,2.34.9,1.23.15,1.47-.3,2.88-.36.48-.02,2-.07,3.42.72.25.14.58.35,2.52,2.52,1.75,1.96,1.71,2.04,2.16,2.34,1.4.93,2,.3,3.96,1.08.7.28,2.83,1.12,3.78,3.06.62,1.27.13,1.78.9,3.06.59.98,1.36,1.5,2.34,2.16,2.13,1.43,2.87,1.05,3.78,2.16.83,1,.96,2.21,1.08,3.24.25,2.18-.51,2.65,0,3.96.23.59.43.61,2.34,2.52,1.54,1.54,2.31,2.32,2.52,2.88.42,1.14.2,2.23-.18,4.14-.37,1.84-.77,2.24-.54,3.24.21.95.68,1.04,1.44,2.34.49.83,1.35,2.31,1.26,3.96-.03.52-.13.62-1.62,3.96-.93,2.07-1.04,2.36-1.08,2.88-.12,1.36.45,1.57.72,3.42.16,1.1.48,3.32-.72,4.68-.56.64-.88.44-1.98,1.44-.48.44-1.17,1.07-1.62,1.98-.56,1.13-.17,1.53-.54,3.78-.23,1.42-.36,2.18-.9,3.06-.8,1.3-1.98,1.96-2.34,2.16-1.24.68-1.55.33-2.34.9-.87.64-.86,1.34-1.8,3.6-.85,2.05-1.28,3.07-1.98,3.6-1.05.79-1.59.27-3.96,1.08-1.21.41-2.26.77-3.24,1.62-1.82,1.58-1.28,3.01-2.88,3.96-.72.42-1.68.46-3.6.54-2.06.08-2.23-.21-3.6,0-.67.1-2.06.33-3.42,1.26-1.59,1.08-1.35,1.9-2.52,2.34-.34.13-.81.23-4.14-.54-2.59-.6-2.39-.68-3.06-.72-1.4-.08-1.69.31-4.68.9-1.84.36-2.78.54-3.42.36-1.46-.41-1.4-1.35-3.42-2.34-.3-.15-1.47-.7-3.06-.9-1.29-.16-1.48.08-2.88,0-1.3-.08-2.65-.15-3.78-.9-1.53-1.01-.93-2.11-2.52-3.6-1.17-1.1-2.58-1.52-4.14-1.98-2.2-.65-2.57-.24-3.42-.9-1.13-.87-.79-1.84-1.98-4.14-.35-.67-1.07-2.04-2.34-3.24-2.2-2.09-3.62-1.38-4.68-3.06-.19-.3-.43-1.77-.9-4.68-.35-2.15-.38-2.5-.72-3.06-.93-1.53-2.04-1.12-3.06-2.52-1.23-1.69-.87-4.04-.72-5.04.3-1.98.96-2.04.9-3.42-.07-1.6-.98-1.8-1.98-4.32-.67-1.69-1.24-3.1-.72-4.5.46-1.23,1.27-1.14,1.98-2.7.56-1.22.55-2.33.54-3.24-.02-2.59-.96-2.78-.72-4.5.29-2.1,1.95-3.62,2.34-3.96,1.03-.89,1.43-.68,1.98-1.44.83-1.14.27-2.07.54-4.32.18-1.48.45-3.75,1.98-4.86,1.19-.86,2.03-.21,3.42-1.26.71-.53,1.07-1.2,1.8-2.52,1.4-2.55,1.07-3.22,2.16-4.32.85-.86,1.82-1.22,2.88-1.62,2.12-.79,2.56-.25,3.78-.9,1.92-1.03,1.3-2.63,3.24-3.96,1.52-1.05,3.37-1.07,4.86-1.08,2.35-.02,2.63.64,3.78.18,1.58-.63,1.38-2.02,3.42-3.24.66-.39,1.64-.98,2.88-.9,1.89.12,2.22,1.67,4.5,1.98,1.24.17,2.33-.13,2.52-.18Z"
            />
            <text
              style={{
                fill: "#fff",
                fontFamily: "JosefinSansRoman-Bold, Josefin Sans",
                fontSize: 31,
                fontVariationSettings: "wght 700",
                fontWeight: 700,
              }}
              transform="translate(7.24 59.68)"
            >
              <tspan x="0" y="0">
                FREE
              </tspan>
            </text>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};
export const PremiumIcon = () => {
  return (
    <SvgIcon className={styles.icon}>
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 99.72 64.19"
      >
        <defs></defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path
              style={{ fill: "#f9f187", strokeWidth: 0 }}
              d="m92.72,25.23c-.26,2.3-.55,3.64-1.68,8.88-1.68,7.81-1.82,8.54-2.4,10.08-1.24,3.31-2.81,5.88-4.08,7.68.34,1.37.72,3.57.48,6.24-.21,2.28-.38,4.2-1.68,5.28-1.66,1.39-4.07.5-7.2,0-2.2-.35-1.31.04-12.72.48-7.24.28-10.86.42-15.36.24-6.51-.26-5.45-.73-9.84-.72-4.37.01-8.4.49-15.84.48-3.62,0-5.41-.13-6.48-1.44-1.05-1.29-1.02-3.25-.96-6.96.02-1.6.14-2.92.24-3.84-.81-1.42-1.99-3.63-3.12-6.48-1.8-4.53-1.11-4.66-3.6-14.16-.85-3.25-1.42-5.07-.96-7.68.37-2.12,1.24-3.75,1.92-4.8,2.95,2.93,5.55,5.05,7.44,6.48,1.88,1.42,2.63,1.83,3.36,2.16,3.05,1.35,5.85,1.15,8.16.96,2.47-.2,4.86-.4,7.44-1.92,2.59-1.53,4.04-3.6,5.04-5.04,2.2-3.16,1.64-4.15,3.6-6.24.83-.89,3.12-3.31,6-3.12,2.45.16,4.11,2.13,5.76,4.08,2.4,2.84,1.87,3.89,4.32,6.72.81.93,2.38,2.71,5.04,4.08.95.49,3.07,1.55,6,1.68,3.78.17,6.57-1.32,7.68-1.92,2.16-1.18,2.2-1.85,6-5.04,3.89-3.26,5.83-4.89,6.96-4.32,1.31.66.96,3.87.48,8.16Z"
            />
            <path
              style={{ fill: "#fdbe2d", strokeWidth: 0 }}
              d="m92.72,25c-.25,2.3-.55,3.64-1.68,8.88-1.68,7.81-1.82,8.54-2.4,10.08-1.24,3.31-2.8,5.88-4.08,7.68.34,1.37.73,3.57.48,6.24-.21,2.28-.38,4.2-1.68,5.28-1.66,1.39-4.07.5-7.2,0-2.2-.35-1.31.04-12.72.48-6.04.23-9.57.37-13.18.3V11.55c.07,0,.14,0,.22,0,2.45.16,4.11,2.13,5.76,4.08,2.41,2.84,1.87,3.89,4.32,6.72.81.93,2.38,2.71,5.04,4.08.95.49,3.07,1.55,6,1.68,3.78.17,6.58-1.31,7.68-1.92,2.16-1.18,2.2-1.85,6-5.04,3.89-3.26,5.84-4.89,6.96-4.32,1.32.67.96,3.87.48,8.16Z"
            />
            <circle
              style={{ fill: "#fdbe2d", strokeWidth: 0 }}
              cx="50"
              cy="9.36"
              r="9.36"
            />
            <circle
              style={{ fill: "#fdbe2d", strokeWidth: 0 }}
              cx="9.36"
              cy="16.31"
              r="9.36"
            />
            <circle
              style={{ fill: "#faa63e", strokeWidth: 0 }}
              cx="90.36"
              cy="16.31"
              r="9.36"
            />
            <path
              style={{ fill: "#faa63e", strokeWidth: 0 }}
              d="m50,52.91h34.56v7.2c0,2.25-1.83,4.08-4.08,4.08h-30.48v-11.28h0Z"
            />
            <path
              style={{ fill: "#fdbe2d", strokeWidth: 0 }}
              d="m15.44,52.91h30.48c2.25,0,4.08,1.83,4.08,4.08v7.2H15.44v-11.28h0Z"
              transform="translate(65.44 117.1) rotate(180)"
            />
            <path
              style={{ fill: "#faa63e", strokeWidth: 0 }}
              d="m59.36,9.36c0,5.17-4.19,9.36-9.36,9.36V0C55.17,0,59.36,4.19,59.36,9.36Z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};
export const MixedIcon = () => {
  return (
    <SvgIcon className={styles.icon}>
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 92.81 79.71"
      >
        <defs></defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <g>
              <path
                style={{ fill: "#f9f187", strokeWidth: "0px" }}
                d="m64.47,17.77c-.18,1.62-.38,2.56-1.17,6.26-1.17,5.5-1.27,6.02-1.67,7.1-.86,2.33-1.95,4.14-2.84,5.41.24.97.5,2.51.33,4.4-.14,1.61-.27,2.96-1.17,3.72-1.16.98-2.83.35-5.01,0-1.53-.25-.91.03-8.84.34-5.03.2-7.55.3-10.68.17-4.52-.18-3.79-.52-6.84-.51-3.04,0-5.84.35-11.01.34-2.52,0-3.76-.09-4.51-1.01-.73-.91-.71-2.29-.67-4.9.02-1.13.1-2.06.17-2.7-.56-1-1.38-2.56-2.17-4.56-1.25-3.19-.77-3.28-2.5-9.97-.59-2.29-.99-3.57-.67-5.41.26-1.49.86-2.64,1.34-3.38,2.05,2.06,3.86,3.56,5.17,4.56,1.3,1,1.83,1.29,2.34,1.52,2.12.95,4.07.81,5.67.68,1.71-.14,3.38-.28,5.17-1.35,1.8-1.07,2.81-2.54,3.5-3.55,1.53-2.23,1.14-2.93,2.5-4.4.58-.62,2.17-2.33,4.17-2.2,1.7.12,2.86,1.5,4.01,2.87,1.67,2,1.3,2.74,3,4.73.56.66,1.66,1.91,3.5,2.87.66.35,2.13,1.09,4.17,1.18,2.63.12,4.57-.93,5.34-1.35,1.5-.83,1.53-1.31,4.17-3.55,2.7-2.3,4.06-3.44,4.84-3.04.91.47.67,2.73.33,5.75Z"
              />
              <path
                style={{ fill: "#fdbe2d", strokeWidth: "0px" }}
                d="m64.47,17.61c-.17,1.62-.38,2.56-1.17,6.26-1.17,5.5-1.27,6.02-1.67,7.1-.86,2.33-1.95,4.14-2.84,5.41.24.97.51,2.51.33,4.4-.15,1.61-.26,2.96-1.17,3.72-1.15.98-2.83.35-5.01,0-1.53-.25-.91.03-8.84.34-4.2.16-6.65.26-9.16.21V8.14s.1,0,.15,0c1.7.11,2.86,1.5,4.01,2.87,1.68,2,1.3,2.74,3,4.73.56.66,1.65,1.91,3.5,2.87.66.35,2.13,1.09,4.17,1.18,2.63.12,4.58-.92,5.34-1.35,1.5-.83,1.53-1.3,4.17-3.55,2.7-2.3,4.06-3.44,4.84-3.04.92.47.67,2.73.33,5.75Z"
              />
              <ellipse
                style={{ fill: "#fdbe2d", strokeWidth: "0px" }}
                cx="34.77"
                cy="6.59"
                rx="6.51"
                ry="6.59"
              />
              <ellipse
                style={{ fill: "#fdbe2d", strokeWidth: "0px" }}
                cx="6.51"
                cy="11.49"
                rx="6.51"
                ry="6.59"
              />
              <ellipse
                style={{ fill: "#faa63e", strokeWidth: "0px" }}
                cx="62.83"
                cy="11.49"
                rx="6.51"
                ry="6.59"
              />
              <path
                style={{ fill: "#faa63e", strokeWidth: "0px" }}
                d="m34.77,37.27h24.03v3.87c0,2.25-1.83,4.08-4.08,4.08h-19.95v-7.95h0Z"
              />
              <path
                style={{ fill: "#fdbe2d", strokeWidth: "0px" }}
                d="m10.74,37.27h19.95c2.25,0,4.08,1.83,4.08,4.08v3.87H10.74v-7.95h0Z"
                transform="translate(45.5 82.49) rotate(180)"
              />
              <path
                style={{ fill: "#faa63e", strokeWidth: "0px" }}
                d="m41.27,6.59c0,3.64-2.91,6.59-6.51,6.59V0C38.36,0,41.27,2.95,41.27,6.59Z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#007864", strokeWidth: "0px" }}
                d="m63.4,22.7c.7-.19.83-.44,1.6-.67.33-.1.9-.24,1.6-.22.51.01,1.4.03,2.17.56.58.4.53.7,1.14,1.12.67.47,1.35.54,1.49.56.78.1.93-.19,1.83-.22.3-.01,1.27-.04,2.17.45.16.09.37.22,1.6,1.57,1.11,1.22,1.09,1.27,1.37,1.46.89.58,1.27.19,2.52.67.44.17,1.8.7,2.4,1.91.4.79.08,1.11.57,1.91.37.61.86.93,1.49,1.35,1.35.89,1.82.65,2.4,1.35.52.62.61,1.38.69,2.02.16,1.36-.33,1.65,0,2.47.15.37.27.38,1.49,1.57.98.96,1.47,1.44,1.6,1.79.27.71.13,1.39-.11,2.58-.23,1.14-.49,1.4-.34,2.02.14.59.43.65.92,1.46.31.52.86,1.44.8,2.47-.02.32-.08.39-1.03,2.47-.59,1.29-.66,1.47-.69,1.79-.07.85.29.98.46,2.13.1.69.3,2.07-.46,2.91-.36.4-.56.27-1.26.9-.31.28-.74.66-1.03,1.23-.36.71-.11.95-.34,2.35-.15.89-.23,1.36-.57,1.91-.51.81-1.26,1.22-1.49,1.35-.79.43-.99.2-1.49.56-.56.4-.55.84-1.14,2.24-.54,1.28-.81,1.91-1.26,2.24-.67.49-1.01.17-2.52.67-.77.26-1.44.48-2.06,1.01-1.16.99-.81,1.88-1.83,2.47-.46.26-1.07.29-2.29.34-1.31.05-1.42-.13-2.29,0-.43.06-1.31.21-2.17.78-1.01.67-.86,1.18-1.6,1.46-.22.08-.52.14-2.63-.34-1.64-.37-1.52-.42-1.94-.45-.89-.05-1.07.19-2.97.56-1.17.23-1.76.34-2.17.22-.93-.25-.89-.84-2.17-1.46-.19-.09-.93-.44-1.94-.56-.82-.1-.94.05-1.83,0-.83-.05-1.69-.1-2.4-.56-.97-.63-.59-1.31-1.6-2.24-.75-.69-1.64-.94-2.63-1.23-1.4-.41-1.64-.15-2.17-.56-.72-.54-.5-1.15-1.26-2.58-.22-.42-.68-1.27-1.49-2.02-1.4-1.3-2.3-.86-2.97-1.91-.12-.19-.27-1.1-.57-2.91-.22-1.34-.24-1.56-.46-1.91-.59-.95-1.3-.7-1.94-1.57-.78-1.05-.55-2.51-.46-3.14.19-1.23.61-1.27.57-2.13-.05-.99-.62-1.12-1.26-2.69-.43-1.05-.79-1.93-.46-2.8.29-.77.81-.71,1.26-1.68.35-.76.35-1.45.34-2.02-.01-1.61-.61-1.73-.46-2.8.19-1.31,1.24-2.25,1.49-2.47.66-.56.91-.43,1.26-.9.53-.71.17-1.29.34-2.69.11-.92.28-2.34,1.26-3.03.76-.54,1.29-.13,2.17-.78.45-.33.68-.75,1.14-1.57.89-1.59.68-2.01,1.37-2.69.54-.54,1.16-.76,1.83-1.01,1.35-.49,1.63-.15,2.4-.56,1.22-.64.83-1.64,2.06-2.47.97-.65,2.14-.66,3.09-.67,1.5-.01,1.67.4,2.4.11,1.01-.39.88-1.26,2.17-2.02.42-.25,1.04-.61,1.83-.56,1.2.08,1.41,1.04,2.86,1.23.79.1,1.48-.08,1.6-.11Z"
              />
              <text
                style={{
                  fill: "#fff",
                  fontFamily: "JosefinSansRoman-Bold, Josefin Sans",
                  fontSize: 19.31,
                  fontVariationSettings: "wght 700",
                  fontWeight: 700,
                }}
                transform="translate(37.45 58.74) scale(1.02 1)"
              >
                <tspan x="0" y="0">
                  FREE
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};
